import React, { useEffect, useState } from 'react'
import dateFormat from 'dateformat'
import { SearchContext } from '../search/SearchContext'
import { fetchRateComments } from '../helpers/hotelHelper'
import ReactMarkdown from 'react-markdown'

const HotelRoomsRateComments = () => {
  const { state: { arrival, room, hotel } } = React.useContext(SearchContext)
  const [comments, setComments] = useState([])

  useEffect( () => {
    if(room)
      _fetchRateComments()
  },[room])

  const _fetchRateComments = async () => {
    const ids = _fetchRateCommentIds()
    if (ids && arrival) {
      const payload = {
        checkin_date: dateFormat(arrival, 'yyyy/mm/dd'), // yyyy-mm-dd
        rate_comments_id: ids // xxx|xx|x...
      }
      let commentsResults = await fetchRateComments(payload)
      if (commentsResults) {
        setComments(commentsResults.rate_comments)
      } else {
        setComments([])
      }
    } else {
      setComments([])
    }
  }

  const _fetchRateCommentIds = () => {
    if (hotel.hotel_type !== 'hotel')
      return false

    if("rates" in room) {
      let ids = undefined
      ids = room.rates.map((rate) => {
        if ("rateCommentsId" in rate) {
          return rate.rateCommentsId
        }
      })
      if(Array.isArray(ids)) return ids[0]
    }
  }

  const _renderRateCommentForRoom = (comments) => {
    if (comments.length == 0) {
      return null
    }

    return (
      <div className="rate-comments">
        <h3>Rate Comments</h3>
        <div>
          { (comments.length > 0) && comments.map((c) => <ReactMarkdown key={c.id} source={c} />) }
        </div>
      </div>
    )
  }

  const _renderComments = () => {
    if (comments) {
      if (Array.isArray(comments)) {
        return _renderRateCommentForRoom(comments)
      } else {
        return Object.keys(comments).map((room, idx) => {
          return (
            <>
              <h3>{room}</h3>
              {_renderRateCommentForRoom(comments[room])}
            </>
          )
        })
      }
    }
  }

  return (
    <React.Fragment>
      {
        room && _renderComments()
      }
    </React.Fragment>
  )
}

export default HotelRoomsRateComments
